
import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_mobile_campaigns = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/mobile`,
        method: "GET",
    });
}

export const create_new_mobile_campaign = async (campaign_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/mobile`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(campaign_data)
    });
}

export const update_mobile_campaign_by_mobile_campaign_id = async (mobile_campaign_id, campaign_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/mobile/id/${mobile_campaign_id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(campaign_data)
    });
}

export const delete_mobile_campaign = async (mobile_campaign_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/mobile/id/${mobile_campaign_id}`,
        method: "DELETE"
    });
}

export const fetch_mobile_campaign_by_id = async (mobile_campaign_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/mobile/id/${mobile_campaign_id}`,
        method: "GET"
    });
}

export const fetch_all_contact_groups = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/groups`,
        method: "GET"
    });
}

export const create_new_contact_group = async (contact_group_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/groups`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contact_group_data)
    });
}

export const update_contact_group_by_id = async (contact_group_id, contact_group_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/groups/id/${contact_group_id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contact_group_data)
    });
}

export const delete_contact_group = async (contact_group_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/groups/id/${contact_group_id}`,
        method: "DELETE"
    });
}

export const fetch_contact_group_by_id = async (contact_group_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/campaigns/groups/id/${contact_group_id}`,
        method: "GET"
    });
}